import { memo } from 'react';
import styled, { type CSSObject } from '@emotion/styled';

import type { ThemeProps } from '@emotion/react';

import Photo from '../Photo';

import type { Maybe, Wws_PhotoAlbum, Wws_Image } from '../../types/graphql';

const AlbumWrap = styled('div')`
  display: flex;
  margin: 24px auto 80px auto;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 960px;

  ${(props: ThemeProps): CSSObject | undefined =>
    props.theme.components.PhotoGallery}
`;

export interface PhotoAlbumProps {
  photoAlbums: Maybe<ReadonlyArray<Wws_PhotoAlbum>> | undefined;
}

function PhotoAlbum({ photoAlbums }: PhotoAlbumProps) {
  if (!photoAlbums?.length) {
    return null;
  }

  // TODO: filter photoAlbums by null in useMemo before rendering. Extract in 2 components/files. Too big On2 complexity for single component render.
  return (
    <>
      {photoAlbums.map((album: Wws_PhotoAlbum, i: number) => {
        if (album.images) {
          return (
            <AlbumWrap key={album.id || i}>
              {album.images.map((image: Wws_Image, index: number) => {
                const prevPhotoId =
                  (album.images && album.images[index - 1]?.id) || undefined;

                const nextPhotoId =
                  (album.images && album.images[index + 1]?.id) || undefined;

                return (
                  <Photo
                    alt={`Album Photo ${index + 1}`}
                    caption={image.caption || ''}
                    id={image.id || index}
                    key={image.id}
                    nextPhotoId={nextPhotoId}
                    path={image.galleryPath || ''}
                    prevPhotoId={prevPhotoId}
                  />
                );
              })}
            </AlbumWrap>
          );
        }

        return null;
      })}
    </>
  );
}

export default memo(PhotoAlbum);
